/**
 * Auto-generated TypeScript permission types
 *
 * DO NOT EDIT THIS FILE MANUALLY!
 * Run 'php artisan permissions:generate-types' to regenerate
 *
 * This file provides type-safe permission definitions that match
 * the backend PHP enums (CustomerPermission and EmployeePermission).
 */
export const EMPLOYEE_PERMISSIONS = {
  ACTIVITY_LOGS_SHOW: 'activity-logs.show',
  BRANDS_ACTIVITY_LOG_VIEW: 'brands.activity-log.view',
  BRANDS_CALLBACK_URL_SHOW: 'brands.callback-url.show',
  BRANDS_CALLBACK_URL_UPDATE: 'brands.callback-url.update',
  BRANDS_CREATE: 'brands.create',
  BRANDS_CREDENTIALS_CREATE: 'brands.credentials.create',
  BRANDS_CREDENTIALS_DELETE: 'brands.credentials.delete',
  BRANDS_CURRENCIES_MANAGE: 'brands.currencies.manage',
  BRANDS_CURRENCIES_SHOW: 'brands.currencies.show',
  BRANDS_DELETE: 'brands.delete',
  BRANDS_GAMES_MANAGE: 'brands.games.manage',
  BRANDS_GAMES_SHOW: 'brands.games.show',
  BRANDS_MARKETS_SHOW: 'brands.markets.show',
  BRANDS_PROVIDER_CREDENTIALS_MANAGE: 'brands.provider-credentials.manage',
  BRANDS_PROVIDER_CREDENTIALS_VIEW: 'brands.provider-credentials.view',
  BRANDS_PROVIDERS_MANAGE: 'brands.providers.manage',
  BRANDS_PROVIDERS_SHOW: 'brands.providers.show',
  BRANDS_PUBLIC_API_TESTING_USE: 'brands.public-api-testing.use',
  BRANDS_SHOW: 'brands.show',
  BRANDS_UPDATE: 'brands.update',
  COMPANIES_ACTIVITY_SHOW: 'companies.activity.show',
  COMPANIES_CREATE: 'companies.create',
  COMPANIES_DELETE: 'companies.delete',
  COMPANIES_INVITATIONS_CREATE: 'companies.invitations.create',
  COMPANIES_INVITATIONS_DELETE: 'companies.invitations.delete',
  COMPANIES_INVITATIONS_SHOW: 'companies.invitations.show',
  COMPANIES_SHOW: 'companies.show',
  COMPANIES_UPDATE: 'companies.update',
  CUSTOMERS_CREATE: 'customers.create',
  CUSTOMERS_DELETE: 'customers.delete',
  CUSTOMERS_ROLES_CREATE: 'customers.roles.create',
  CUSTOMERS_ROLES_DELETE: 'customers.roles.delete',
  CUSTOMERS_ROLES_UPDATE: 'customers.roles.update',
  CUSTOMERS_SHOW: 'customers.show',
  CUSTOMERS_UPDATE: 'customers.update',
  DISCOUNT_PROGRAMS_MANAGE: 'discount-programs.manage',
  DISCOUNT_PROGRAMS_SHOW: 'discount-programs.show',
  EMPLOYEES_ASSIGN_PERMISSION: 'employees.assign-permission',
  EMPLOYEES_ASSIGN_ROLE: 'employees.assign-role',
  EMPLOYEES_CREATE: 'employees.create',
  EMPLOYEES_DELETE: 'employees.delete',
  EMPLOYEES_MANAGE_SUPER_EMPLOYEE: 'employees.manage-super-employee',
  EMPLOYEES_ROLES_CREATE: 'employees.roles.create',
  EMPLOYEES_ROLES_DELETE: 'employees.roles.delete',
  EMPLOYEES_ROLES_SHOW: 'employees.roles.show',
  EMPLOYEES_ROLES_UPDATE: 'employees.roles.update',
  EMPLOYEES_SHOW: 'employees.show',
  EMPLOYEES_UPDATE: 'employees.update',
  EXCHANGE_RATES_SHOW: 'exchange-rates.show',
  GAMES_CREATE: 'games.create',
  GAMES_DELETE: 'games.delete',
  GAMES_SHOW: 'games.show',
  GAMES_UPDATE: 'games.update',
  INVOICES_AGING_SHOW: 'invoices.aging.show',
  INVOICES_COMMISSIONS_MANAGE: 'invoices.commissions.manage',
  INVOICES_COMMISSIONS_SHOW: 'invoices.commissions.show',
  INVOICES_DISCOUNTS_MANAGE: 'invoices.discounts.manage',
  INVOICES_LOCK_MANAGE: 'invoices.lock.manage',
  INVOICES_PAYMENT_MANAGE: 'invoices.payment.manage',
  INVOICES_SHOW: 'invoices.show',
  MAIN_PROVIDERS_CREATE: 'main-providers.create',
  MAIN_PROVIDERS_DELETE: 'main-providers.delete',
  MAIN_PROVIDERS_SHOW: 'main-providers.show',
  MAIN_PROVIDERS_UPDATE: 'main-providers.update',
  ORGANIZATIONS_CREATE: 'organizations.create',
  ORGANIZATIONS_DELETE: 'organizations.delete',
  ORGANIZATIONS_SHOW: 'organizations.show',
  ORGANIZATIONS_UPDATE: 'organizations.update',
  PLAYERS_SHOW: 'players.show',
  PROVIDERS_CREATE: 'providers.create',
  PROVIDERS_DELETE: 'providers.delete',
  PROVIDERS_SHOW: 'providers.show',
  PROVIDERS_UPDATE: 'providers.update',
  REPORTS_GAMBLING_SUMMARY_SHOW: 'reports.gambling-summary.show',
  REPORTS_GAMES_SHOW: 'reports.games.show',
  REPORTS_PLAYERS_SHOW: 'reports.players.show',
  REPORTS_PROMOTIONS_SHOW: 'reports.promotions.show',
  SYSTEM_SETTINGS_MANAGE: 'system.settings.manage',
  TRANSACTIONS_CANCEL: 'transactions.cancel',
  TRANSACTIONS_SHOW: 'transactions.show',
  TRANSLATIONS_MANAGE: 'translations.manage',
} as const;

export const CUSTOMER_PERMISSIONS = {
  BRANDS_ACTIVITY_LOG_VIEW: 'brands.activity-log.view',
  BRANDS_CALLBACK_TESTS_RUN: 'brands.callback-tests.run',
  BRANDS_CALLBACK_TESTS_VIEW: 'brands.callback-tests.view',
  BRANDS_CALLBACK_URLS_UPDATE: 'brands.callback-urls.update',
  BRANDS_CALLBACK_URLS_VIEW: 'brands.callback-urls.view',
  BRANDS_CREDENTIALS_DELETE: 'brands.credentials.delete',
  BRANDS_CREDENTIALS_GENERATE: 'brands.credentials.generate',
  BRANDS_CURRENCIES_UPDATE: 'brands.currencies.update',
  BRANDS_CURRENCIES_VIEW: 'brands.currencies.view',
  BRANDS_EDIT: 'brands.edit',
  BRANDS_GAMES_VIEW: 'brands.games.view',
  BRANDS_MARKETS_VIEW: 'brands.markets.view',
  BRANDS_PROVIDERS_VIEW: 'brands.providers.view',
  BRANDS_PUBLIC_API_TESTING_USE: 'brands.public-api-testing.use',
  BRANDS_VIEW: 'brands.view',
  COMPANY_ACTIVITY_LOG_VIEW: 'company.activity-log.view',
  COMPANY_SETTINGS_EDIT: 'company.settings.edit',
  COMPANY_SETTINGS_VIEW: 'company.settings.view',
  PLAYERS_VIEW: 'players.view',
  REPORTS_GAMBLING_SUMMARY_EXPORT: 'reports.gambling-summary.export',
  REPORTS_GAMBLING_SUMMARY_VIEW: 'reports.gambling-summary.view',
  REPORTS_GAMES_VIEW: 'reports.games.view',
  REPORTS_PLAYERS_EXPORT: 'reports.players.export',
  REPORTS_PLAYERS_VIEW: 'reports.players.view',
  REPORTS_PROMOTIONS_EXPORT: 'reports.promotions.export',
  REPORTS_PROMOTIONS_VIEW: 'reports.promotions.view',
  ROLES_CREATE: 'roles.create',
  ROLES_INDEX: 'roles.index',
  ROLES_UPDATE: 'roles.update',
  TRANSACTIONS_VIEW: 'transactions.view',
  USERS_INVITE_CREATE: 'users.invite.create',
  USERS_INVITE_LIST: 'users.invite.list',
  USERS_INVITE_REMOVE: 'users.invite.remove',
  USERS_MANAGE: 'users.manage',
  USERS_MANAGE_OWNER: 'users.manage-owner',
  USERS_REMOVE: 'users.remove',
  USERS_VIEW: 'users.view',
} as const;

// Types derived from const objects (no duplication!)
export type EmployeePermission = (typeof EMPLOYEE_PERMISSIONS)[keyof typeof EMPLOYEE_PERMISSIONS];
export type CustomerPermission = (typeof CUSTOMER_PERMISSIONS)[keyof typeof CUSTOMER_PERMISSIONS];
export type Permission = EmployeePermission | CustomerPermission;

// Helper functions to check if a string is a valid permission
export function isEmployeePermission(permission: string): permission is EmployeePermission {
  return Object.values(EMPLOYEE_PERMISSIONS).includes(permission as EmployeePermission);
}

export function isCustomerPermission(permission: string): permission is CustomerPermission {
  return Object.values(CUSTOMER_PERMISSIONS).includes(permission as CustomerPermission);
}

export function isPermission(permission: string): permission is Permission {
  return isEmployeePermission(permission) || isCustomerPermission(permission);
}
